import React from 'react';
import { Row, Col, Typography } from 'antd';
import { useIsDigitalOrDigitalAgent } from "src/hooks/useIsDigitalOrDigitalAgent";
import { useAppDispatch, useAppSelector } from 'src/hooks/useRedux';
import styles from "./styles.module.scss";
import { toggleShowStringKeys } from 'src/redux/slices/appSlice/AppSlice';

const { Link } = Typography;

const AppFooter = () => {
  const isDigitalOrAgent = useIsDigitalOrDigitalAgent();
  const { strings, mockDataEnabled, showStringKeys } = useAppSelector((state) => state.app);
  const currentUrl = window.location.href.toLowerCase();
  const dispatch = useAppDispatch();
  const isDevOrStaging =
    currentUrl.includes("dev") ||
    currentUrl.includes("stage") ||
    currentUrl.includes("localhost");
  if (isDigitalOrAgent) {
    return null;
  }

  return (
    <div className={styles.footer}>
      <Row justify="center" align="middle">
        <Col xs={24}>
          <div className={styles.footerLinksContainer}>
            <Link href="https://www.passportcard.co.il/accessibility-statement/" target="_blank" rel="noopener noreferrer">
              {strings.t_footer_accessibility_statement}
            </Link>
            <span>|</span>
            <span>{strings.t_footer_security_statement}</span>
            <Link href="https://www.passportcard.co.il/privacy-policy/" target="_blank" rel="noopener noreferrer">
              {strings.t_footer_privacy_policy}
            </Link>
            <span>|</span>
            <Link href="https://www.passportcard.co.il/terms-and-conditions/" target="_blank" rel="noopener noreferrer">
              {strings.t_footer_terms_of_use}
            </Link>
          </div>
          {
            isDevOrStaging && (
              <div className={styles.footerDevEnv}>
                <span>Is Mock Data Enabled :  {mockDataEnabled?.toString()?.toUpperCase()}</span>
                <button
                  onClick={() => dispatch(toggleShowStringKeys())}
                  style={{
                    background: showStringKeys ? 'transparent' : 'transparent',
                    border: '1px solid #ccc',
                    padding: '4px 12px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    marginLeft: '16px',
                    color: 'white'
                  }}
                >
                  {showStringKeys ? 'Hide Keys' : 'Show Keys'}
                </button>
              </div>
              
            )
          }
        </Col>
      </Row>
    </div>
  );
};

export default AppFooter;